const CLASS_DIALOG_BODY_OPEN = 'dialog__body--open';

export { CLASS_DIALOG_BODY_OPEN };
//# sourceMappingURL=className.js.map
